import {Component, EventEmitter, forwardRef, Input, OnInit, Output, SimpleChanges} from '@angular/core';
import {
  AbstractControl,
  UntypedFormControl,
  UntypedFormGroup,
  NG_VALIDATORS,
  NG_VALUE_ACCESSOR,
  ValidationErrors,
  Validators, UntypedFormArray, FormBuilder
} from "@angular/forms";
import {SharedService} from "../../../../shared/shared.service";
import {CoreService} from "../../../../../services/core/core.service";
import {DialogService} from "../../../../../services/core/dialog.service";
import {first, Subscription} from "rxjs";
import {pairwise, startWith} from "rxjs/operators";

@Component({
    selector: 'app-subcontractor-add-covered-area-form',
    templateUrl: './subcontractor-add-covered-area-form.component.html',
    styleUrls: ['./subcontractor-add-covered-area-form.component.scss'],
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: forwardRef(() => SubcontractorAddCoveredAreaFormComponent),
            multi: true
        },
        {
            provide: NG_VALIDATORS,
            useExisting: forwardRef(() => SubcontractorAddCoveredAreaFormComponent),
            multi: true
        }
    ],
    standalone: false
})
export class SubcontractorAddCoveredAreaFormComponent implements OnInit {

  @Input() model: any = {};
  @Input() form: any = {};
  @Input() isEdit: boolean = false;
  @Output() callback = new EventEmitter<any>(true);
  @Output() onInitForm = new EventEmitter<any>(true);
  //@ts-ignore
  public addCoveredAreaSubcontractorFormSubscription: Subscription;
  public states:any[] = [];

  // public addCoveredAreaSubcontractorForm: UntypedFormGroup = new UntypedFormGroup({
  //   states: new UntypedFormControl(null),
  //   covered_areas: new UntypedFormControl(null),
  // });

  public addCoveredAreaSubcontractorForm: UntypedFormGroup = new UntypedFormGroup({
    states: new UntypedFormControl(null),
    covered_areas: new UntypedFormArray([]),
  });

  constructor(
    public sharedService: SharedService,
    public coreService: CoreService,
    public dialogService: DialogService,
    public fb: FormBuilder,
  ) { }


  ngOnChanges(changes: SimpleChanges) {
    this.getStates();
    this.model = changes?.model?.currentValue;
  }

  ngOnInit(): void {
    this.initSubscriptions();

  }

  placeChangedCallback = (event:any) => {
    console.log('placeChangedCallback', event);
  }

  getStates = () => {
    return this.sharedService.getAllStates()
      .pipe(first())
      .subscribe(
        (data:any) => {
          // console.log('data11111111111111111111111111111111111111111111111111111111111111111', data);
          this.states = data?.data?.map((state:any)=>{
            // console.log(state, '+++++++++++++++++++++++++++++');
            return {id: state?.id, name: state?.name};
          });
          // console.log(this.states, '----------------------------------------');
        });
  }

  ngAfterViewInit(): void {
    this.setDataOnEdit();
  }

  setDataOnEdit = () => {
    if(this.isEdit) {
      // this.addCoveredAreaSubcontractorForm?.setValue({
      //   name: this.model?.name,
      //   email: this.model?.email,
      //   phone: this.model?.phone,
      //   alternate_phone: this.model?.alternate_phone,
      // });
      this.model?.covered_areas?.map((item: any) => {
        // console.log('modell',item);
        this.newCoveredArea(item);
      })
    }
  }

  public onTouched: () => void = () => {};

  writeValue(val: any): void {
    val && this.addCoveredAreaSubcontractorForm.setValue(val, { emitEvent: false });
  }

  registerOnChange(fn: any): void {
    this.addCoveredAreaSubcontractorForm.valueChanges.subscribe(fn);
  }

  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }

  setDisabledState?(isDisabled: boolean): void {
    isDisabled ? this.addCoveredAreaSubcontractorForm.disable() : this.addCoveredAreaSubcontractorForm.enable();
  }

  validate(c: AbstractControl): ValidationErrors | null{
    return this.addCoveredAreaSubcontractorForm.valid ? null : { invalidForm: {valid: false, message: "Subcontractor fields are invalid"}};
  }

  initSubscriptions(){
    if (this.form){
      this.addCoveredAreaSubcontractorFormSubscription = this.form.valueChanges
        .pipe(startWith(null), pairwise())
        .subscribe(([prev, next]: [any, any]) => {
          if (this.form.touched){
            this.touchFormControls();
          }
        });
    }

  }
  touchFormControls(){
    Object.keys(this.addCoveredAreaSubcontractorForm.controls).forEach(key => {
      this.addCoveredAreaSubcontractorForm.get(key)?.markAsTouched();
    });
  }

  ngOnDestroy(){
    // prevent memory leak when component destroyed
    this.addCoveredAreaSubcontractorFormSubscription?.unsubscribe();
  }


  areas(): UntypedFormArray {
    return this.addCoveredAreaSubcontractorForm.get('covered_areas') as UntypedFormArray;
  }

  newCoveredArea(area: any) {
    this.areas().push(this.addCoveredArea(area));
  }

  addCoveredArea(area: any) {
    return this.fb.group({
      id: [area ? area?.id : null],
      state_id:[ area ?  area?.state?.id : null],
      state_name: [area ? area?.state?.name: null],
      zipcode: null,
      covered_areas: [area ? area?.covered_areas : null],
    })
  }

  selectedStates(event: any) {
    const state = this.addCoveredAreaSubcontractorForm?.get('states')?.value;
    this.newCoveredArea({state:state});
    this.addCoveredAreaSubcontractorForm?.get('states')?.setValue(null);
  }

  addZipCode(event: any, index: any) {
    const value = this.areas().at(index)?.get('zipcode')?.value;
    if(value) {
      const areas = this.areas().at(index)?.get('covered_areas')?.value;
      if (areas == null) {
        const data: any = [];
        data.push(value);
        this.areas().at(index)?.get('covered_areas')?.setValue(data);
      } else {
        areas.push(value);
        this.areas().at(index)?.get('covered_areas')?.setValue(areas);
      }
      this.areas().at(index)?.get('zipcode')?.setValue(null);
    }
  }

  removeArea(area: any, index: any) {
    const data = this.areas().at(index)?.get('covered_areas')?.value;
    const valueIndex = data.findIndex((x: any) => x == area);
    if(valueIndex != -1) {
      data.splice(valueIndex,1);
    }
    console.log('event',data)
    this.areas().at(index)?.get('covered_areas')?.setValue(data);
  }

  removeState(index: any) {
    this.areas().removeAt(index);
  }
}
